import { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../../context";
import { publicRoutes } from "../../routes";
import { NavigationStyled } from "./NavigationStyled";

const Navigation = () => {

  const { isDesktop, openModal } = useContext(AppContext)


  return (
    <NavigationStyled>
      <ul className="navList list" >
        {publicRoutes.map(({ name, path }) => name && <li key={name} className="navListItem" onClick={!isDesktop ? openModal : null} >
          <NavLink
            to={path}
            className={({ isActive }) =>
              isActive ? "link active-link" : "link"
            }
            exact="true"
          >
            {name}
          </NavLink>
        </li>)}
      </ul>
    </NavigationStyled >
  );
};

export default Navigation;
